import { Button, Card, MediaCard, Page, Text } from '@ui/themed';
import { t } from 'i18next';
import { adminBookCall, frame29 } from '../../../assets';
import { isShopify, useEnv } from '../../../context/env-context';
import { useHandlers, useUser, withPageProviders } from '../../../context/page-context';
import { getShopifyAppLink } from '../../../lib/shopify';
import { GridCard } from '../components/GridCard';
import { PartnerContent } from './help-partner';

export const HelpPage = withPageProviders(HelpPageContents);

function HelpPageContents() {
  const env = useEnv();
  const { navigationHandler } = useHandlers();
  const { firstName } = useUser();

  function navigateGettingStarted() {
    if (env.store_id) {
      if (isShopify(env.connected_platform)) {
        navigationHandler.navigate(`${getShopifyAppLink(env.store_id)}/theme-setup`, {
          absolute: true,
          newTab: true,
        });
        return;
      }
    }
    // TODO: Update to handle other platforms
    navigationHandler.navigate('https://docs.sparklayer.io/getting-started', {
      absolute: true,
      newTab: true,
    });
  }

  if (env.team.is_partner) {
    return <PartnerContent />;
  }

  return (
    <Page title={t('features:help.pages.help.title', { firstName: firstName || '' })}>
      {/* Onboarding Actions */}
      <div className="flex flex-row gap-4">
        <div className="flex-1">
          <MediaCard
            imgSrc={frame29}
            imgFit="cover"
            title={t('features:help.pages.help.onboarding.install.title')}
            headingLevel="h2"
            description={t('features:help.pages.help.onboarding.install.body')}
            action={{
              content: t('features:help.pages.help.onboarding.install.action'),
              icon: 'checkCircle',
              onClick: navigateGettingStarted,
            }}
          />
        </div>
        <div className="flex-1">
          <MediaCard
            imgSrc={adminBookCall}
            imgFit="cover"
            title={t('features:help.pages.help.onboarding.book_call.title')}
            headingLevel="h2"
            description={t('features:help.pages.help.onboarding.book_call.body')}
            action={{
              content: t('features:help.pages.help.onboarding.book_call.action'),
              icon: 'chat',
              onClick: () => {},
            }}
            buttonClassName="trigger-intercom-onboarding"
          />
        </div>
      </div>

      {/* Help Grid */}
      <div className="flex flex-col gap-2">
        <div className="flex flex-1 gap-2">
          <GridCard
            icon="document"
            title={t('features:help.pages.help.help_grid.documentation_and_features.title')}
            body={t('features:help.pages.help.help_grid.documentation_and_features.body')}
            isExternal={true}
            action={() =>
              navigationHandler.navigate('https://docs.sparklayer.io', {
                absolute: true,
                newTab: true,
              })
            }
          />
          <GridCard
            icon="user"
            title={t('features:help.pages.help.help_grid.technical_support.title')}
            body={t('features:help.pages.help.help_grid.technical_support.body')}
            isExternal={false}
            className="trigger-intercom-contact"
          />
        </div>
        <div className="flex flex-1 gap-2">
          <GridCard
            icon="chat"
            title={t('features:help.pages.help.help_grid.book_call.title')}
            body={t('features:help.pages.help.help_grid.book_call.body')}
            isExternal={false}
            className="trigger-intercom-onboarding"
          />
          <GridCard
            icon="userGroup"
            title={t('features:help.pages.help.help_grid.general_questions.title')}
            body={t('features:help.pages.help.help_grid.general_questions.body')}
            isExternal={false}
            className="trigger-intercom-contact"
          />
        </div>
      </div>

      {/* Partner actions */}
      <Card>
        <Card.Header headingLevel="h2" icon="upgrade">
          {t('features:help.pages.help.partner_actions.title')}
        </Card.Header>
        <Card.Body>
          <Text>{t('features:help.pages.help.partner_actions.body')}</Text>
          <div className="flex gap-2">
            <Button
              variant="secondary"
              icon="externalLink"
              onClick={() => {
                navigationHandler.navigate(
                  'https://sparklayer.introw.io/forms/x9kvtg423rqheqb1vl3wi26v',
                  {
                    absolute: true,
                    newTab: true,
                  },
                );
              }}
            >
              {t('features:help.pages.help.partner_actions.partner_apply')}
            </Button>
          </div>
        </Card.Body>
      </Card>
    </Page>
  );
}
